import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import SignIn from "./views/SignIn.vue"
import User from "./views/User.vue"
import Manage from "./views/Manage.vue"
import Config from "./views/Config.vue"
import Restricted from "./views/Restricted.vue"
import Whitelist from "./views/Whitelist.vue"
import Logs from "./views/Logs.vue"
import Store from './store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn
    },
    {
      path: '/manage',
      name: 'manage',
      component: Manage,
      beforeEnter: requireAuth
    },
    {
      path: '/config',
      name: 'config',
      component: Config,
      beforeEnter: requireSystemAdminAuth
    },
    {
      path: '/restricted',
      name: 'restricted',
      component: Restricted,
      beforeEnter: requireSystemAdminAuth
    },
    {
      path: '/whitelist',
      name: 'whitelist',
      component: Whitelist,
      beforeEnter: requireSystemAdminAuth
    },
    {
      path: '/logs',
      name: 'logs',
      component: Logs,
      beforeEnter: requireSystemAdminAuth
    },
    {
      path: '/:id',
      name: 'user',
      component: User
    }
  ]
})

router.beforeEach((to, from, next) => {
  let sub = global.location.host
  if (sub.includes("mers")) {
    Store.commit("user/setMERSBranded", true)
  }
  next()
})

async function requireAuth(to, from, next) {
  if (Store.getters["user/isAuthenticated"] && (Store.getters["user/userGroup"] === "Super") || Store.getters["user/userGroup"] === "SystemAdmin") {
    next()
  } else {
    if (await Store.dispatch("user/checkUser") && (Store.getters["user/userGroup"] === "Super") || Store.getters["user/userGroup"] === "SystemAdmin") {
      next()
    } else {
      next("/")
    }
  }
}
async function requireSystemAdminAuth(to, from, next) {
  if (Store.getters["user/isAuthenticated"] && Store.getters["user/userGroup"] === "SystemAdmin") {
    next()
  } else {
    if (await Store.dispatch("user/checkUser") && Store.getters["user/userGroup"] === "SystemAdmin") {
      next()
    } else {
      next("/")
    }
  }
}

export default router